import React, { useEffect } from 'react';
import { forgerockLoginUrl } from '../../api/auth';
import Loading from '../../components/loading/loading';
import { getRedirectPath, goToRedirectPath, setRedirectPath } from '../../utils/appUtils';
import { useSearchParams } from '../utils/use-search-params';
import './style.scss';

export function Login() {
  const search = useSearchParams();
  const redirect = search.get('redirect');

  if (!redirect) {
    throw new Error('No redirect path provided');
  }

  useEffect(() => {
    const redirectPath = getRedirectPath();
    if (redirectPath) {
      goToRedirectPath();
      return;
    }
    setRedirectPath(redirect);
    forgerockLoginUrl().then((url) => {
      window.location.href = url;
    });
  }, [redirect]);

  return <Loading classNames={{ container: 'loginLanding' }} size={64} contained />;
}
